<!--应用列表在移动端浏览器中的样子，进入场景：直接在手机微信中点击-->
<template>
  <div class="mobile-app-list">
    <!-- 顶部Banner -->
    <div class="mobile-banner">
      <el-image class="banner-image" :src="backImage" fit="cover">
        <div slot="error" class="banner-error">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>

    <!-- 主内容区域 -->
    <div class="mobile-content glass">
      <!-- 标签页 -->
      <van-tabs
        :color="lineColor"
        v-model="activeName"
        :swipeable="true"
        :animated="true"
        class="mobile-tabs">
        <van-tab
          :title-style="{fontSize:'1.1rem', fontWeight: '500'}"
          v-for="(item,index) in dataList"
          :key="index"
          :title="item.name">

          <!-- 应用网格 -->
          <div class="mobile-app-grid">
            <div
              class="mobile-app-card"
              @click="getSubAppCallback(i)"
              v-for="(i,index2) in item.appList"
              :key="index2">
              <div class="mobile-app-icon-wrapper">
                <el-image
                  class="mobile-app-icon"
                  :src="i.icon_url"
                  fit="contain">
                  <div slot="error" class="icon-error">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div class="mobile-app-icon-glow"></div>
              </div>
              <span class="mobile-app-name">{{ i.name }}</span>
            </div>
          </div>

        </van-tab>
      </van-tabs>
    </div>

    <!-- 底部用户信息 -->
    <div class="mobile-footer">
      <div class="user-info-section">
        <!-- 用户信息 -->
        <div class="user-info-left">
          <div class="user-info-item">
            <div class="info-icon-wrapper">
              <i class="el-icon-phone-outline"></i>
            </div>
            <div class="info-text-wrapper">
              <div class="info-label">手机号码</div>
              <div class="info-value" v-if="userInfo.app_user.user_phone !== undefined">
                {{ userInfo.app_user.user_phone }}
              </div>
              <div class="info-value" v-else>暂无</div>
            </div>
          </div>

          <div class="user-info-item" v-if="userInfo.school.card_number !== undefined">
            <div class="info-icon-wrapper">
              <i class="el-icon-bank-card"></i>
            </div>
            <div class="info-text-wrapper">
              <div class="info-label">校园卡号</div>
              <div class="info-value">{{ userInfo.school.card_number }}</div>
            </div>
          </div>

          <div class="user-info-item" v-else-if="userInfo.app_user.id_card !== undefined">
            <div class="info-icon-wrapper">
              <i class="el-icon-postcard"></i>
            </div>
            <div class="info-text-wrapper">
              <div class="info-label">身份证号</div>
              <div class="info-value">{{ userInfo.app_user.id_card }}</div>
            </div>
          </div>
        </div>

        <!-- 认证状态 -->
        <div class="auth-section">
          <div
            v-if="!userInfo.bind_school_identity"
            @click="gotoRenZheng"
            class="auth-card auth-pending">
            <div class="auth-icon">
              <i class="el-icon-warning-outline"></i>
            </div>
            <div class="auth-content">
              <div class="auth-title">您还未身份验证</div>
              <div class="auth-desc">点击立即前往</div>
            </div>
          </div>

          <div v-if="userInfo.bind_school_identity" class="auth-card auth-verified">
            <div class="auth-icon">
              <i class="el-icon-success"></i>
            </div>
            <div class="auth-content">
              <div class="auth-title">已认证</div>
              <div class="auth-desc">前往易班认证</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as clientUtils from "@/axios/ClientUtils";

export default {
  name: "AppListMobile",
  data() {
    return {
      // 用户详细信息
      userInfo: {},
      //筛选之后的数据源
      dataList: [],
      activeName: '迎新专栏',
      app_id: '',

      //动态banner图片
      backImage: '',
      lineColor: ''

    }
  },
  mounted() {
    this.app_id = localStorage.getItem('app_id')
    if (parseInt(this.app_id) === 1) {
      this.backImage = 'https://moyo-synu-login-v2-prod.cdn.bcebos.com/banner.png'
      this.lineColor = '#00ffc7'
    } else if (parseInt(this.app_id) === 2) {
      this.backImage = 'https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/assests/dhd/banner/banner-3.png'
      this.lineColor = '#00f6fb'
    } else if (parseInt(this.app_id) === 3) {
      this.backImage = 'https://moyo-synu-login-v2-prod.cdn.bcebos.com/auto-login-v2/assests/lnzy/banner/banner-1.png'
      this.lineColor = '#ff2838'
    }

    this.getUserInfo()
  },
  methods: {

    gotoRenZheng(){
      this.$notify.error({
        title: '请前往小程序客户端认证',
        message:''
      });
    },

    //退出登录事件
    logout() {
      localStorage.setItem("token", '')
      this.$router.replace("userLoginPC")
    },

    //获取全部应用数据
    getMenu() {
      const that = this
      clientUtils.get("/autoLogin/v2/pri/app/show/menu", function (res) {
        console.log(res)
        let initList = res.data.data.sub_app_list
        let menuList = res.data.data.menu_config

        let psList = []

        // 开始剔除不该显示的app对象，遍历menulist
        for (let i = 0; i < menuList.length; i++) {
          // 遍历menu中每一项的subapp，判断hide值
          for (let j = 0; j < menuList[i].sub_apps.length; j++) {


            // 排除hide，是否隐藏字段
            if (menuList[i].sub_apps[j].hide === false && menuList[i].sub_apps[j].only_mini_app !== true) {

              for (let k = 0; k < initList.length; k++) {

                if (initList[k].id === menuList[i].sub_apps[j].id) {
                  // 匹配到该app后首先判断认证字段是否为true，人员的认证字段是否为true，并且app的认证字段不得为undifined
                  //符合的情况下就要去匹配type，xy，zy，此时schoolID和userID不存在不需要判断
                  if (initList[k].view_rules.need_identity === true && that
                      .userInfo
                      .bind_school_identity === true && initList[k].view_rules
                      .need_identity !== undefined) {

                    if (initList[k].view_rules.need_identity === true && that
                        .userInfo.bind_school_identity === true) {
                      // 首先判断schoolids存在不存在
                      if (initList[k].view_rules.school_ids !== undefined) {
                        initList[k].view_rules.school_ids.map((item) => {
                          console.log(initList[k])
                          console.log(item + ' ' + that.userInfo
                              .school.school_id)
                          if (item === that.userInfo.school
                              .school_id) {
                            psList.push(initList[k])
                            console.log("推入成功")
                          }
                        })
                      }
                    }


                    // 只有认证信息匹配，其他的条件都没有
                    if ((initList[k].view_rules.need_identity && that.userInfo
                            .bind_school_identity) && initList[k].view_rules
                            .type === undefined && initList[k].view_rules.xy ===
                        undefined && initList[k].view_rules.zy === undefined &&
                        initList[k].view_rules.school_ids === undefined &&
                        initList[k].view_rules.app_user_ids === undefined) {
                      psList.push(initList[k])
                    }


                    //type不为空并且跟用户信息匹配
                    if (initList[k].view_rules.type !== undefined && that
                        .userInfo.school.type.value === initList[k].view_rules
                        .type) {
                      //学院信息不为空并跟用户匹配
                      if (initList[k].view_rules.xy !== undefined && that
                          .userInfo.school.xy === initList[k].view_rules.xy
                      ) {
                        //专业信息不为空并跟用户匹配
                        if (initList[k].view_rules.zy !== undefined && that
                            .userInfo.school.zy === initList[k].view_rules
                            .zy) {

                          if (initList[k].view_rules.need_identity ===
                              this.userInfo.bind_school_identity) {
                            psList.push(initList[k])
                          }

                          //学院信息匹配 专业信息不存在
                        } else if (initList[k].view_rules.zy ===
                            undefined) {
                          if (initList[k].view_rules.need_identity ===
                              that.userInfo.bind_school_identity) {
                            psList.push(initList[k])
                          }
                        }
                        //专业信息匹配，并不存在xy信息的情况（没有xy一定没有zy）
                      } else if (initList[k].view_rules.xy === undefined) {
                        if (initList[k].view_rules.need_identity === that
                            .userInfo.bind_school_identity) {
                          psList.push(initList[k])
                        }
                      }
                      //type为空并且学院不为空
                    } else if (initList[k].view_rules.type === undefined &&
                        initList[k].view_rules.xy !== undefined && initList[k]
                            .view_rules.xy === that.userInfo.school.xy) {
                      //专业信息不为空并跟用户匹配
                      if (initList[k].view_rules.zy !== undefined && that
                          .userInfo.school.zy === initList[k].view_rules.zy
                      ) {
                        if (initList[k].view_rules.need_identity === that
                            .userInfo.bind_school_identity) {
                          psList.push(initList[k])
                        }
                        //学院信息匹配 专业信息不存在
                      } else if (initList[k].view_rules.zy === undefined) {
                        if (initList[k].view_rules.need_identity === that
                            .userInfo.bind_school_identity) {
                          psList.push(initList[k])
                        }
                      }
                    }


                  } else if (initList[k].view_rules.need_identity ===
                      undefined || initList[k].view_rules.need_identity === false
                  ) {
                    // 此处代表这个应用不需要认证,但是需要检查该用户id在不在schoolID/userID集合中
                    console.log(initList[k].name)
                    if (initList[k].view_rules.app_user_ids !==
                        undefined) {
                      initList[k].view_rules.app_user_ids.map((item) => {
                        console.log(item + ' ' + that.userInfo
                            .app_user.app_user_id)
                        if (item === that.userInfo.app_user
                            .app_user_id) {
                          psList.push(initList[k])
                          console.log(initList[k].name)
                        }
                      })
                      //此时代表userids和schoolids都为空
                    } else if (initList[k].view_rules.app_user_ids ===
                        undefined && initList[k].view_rules.school_ids ===
                        undefined) {
                      psList.push(initList[k])
                    }

                  } else if (initList[k].view_rules.need_identity && !that
                      .userInfo.bind_school_identity && initList[k].view_rules
                      .need_identity !== undefined) {
                    // 此时代表该应用需要认证，但用户并未完成认证，则该app不显示，直接break出去

                  }
                } //第三层里第一个if，判断id是否相等的那个

              } //第三层花括号 k
            } //判断hide的那个花扣号
            else {
              console.log(menuList[i].sub_apps[j].hide + "" + menuList[i].sub_apps[j]
                  .id)
            }

          } //第二层for 循环花括号 j
        } //最外层for循环花括号 i

        // 此时初步筛选appLits成功，开始组装最后的数据源
        let resultList = []
        for (let i = 0; i < menuList.length; i++) {
          resultList.push({
            name: menuList[i].name,
            appList: []
          })
          for (let j = 0; j < menuList[i].sub_apps.length; j++) {
            psList.map((item) => {
              if (menuList[i].sub_apps[j].hide === false) {
                if (item.id === menuList[i].sub_apps[j].id) {
                  let obj = item
                  obj.order = menuList[i].sub_apps[j].order
                  resultList[i].appList.push(obj)
                }
              }
            })
          }
        }

        for (let i = 0; i < resultList.length; i++) {
          if (resultList[i].appList.length === 0) {
            resultList.splice(i, 1)
          }
        }


        // 开始数组去重
        for (let i = 0; i < resultList.length; i++) {
          for (let j = 0; j < resultList[i].appList.length; j++) {
            for (let k = j + 1; k < resultList[i].appList.length; k++) {
              if (resultList[i].appList[j] === resultList[i].appList[
                  k]) { //第一个等同于第二个，splice方法删除第二个
                resultList[i].appList.splice(k, 1);
                k--;
              }
            }
          }
        }

        for (let i = 0; i < resultList.length; i++) {
          resultList[i].appList.sort(function (a, b) {
            return a.order - b.order
          })
        }

        console.log('最终resultList')
        console.log(resultList)
        that.dataList = resultList
        that.activeName = resultList[0].name

      })

    },


    //点击子应用时调用该方法，获取子应用回调地址等信息
    getSubAppCallback(item) {
      console.log(item)

      const tokenUserInfo = localStorage.getItem('token')
      const appIdUserInfo = localStorage.getItem('app_id')
      var myHeaders = new Headers();
      myHeaders.append("app-id", appIdUserInfo);
      myHeaders.append("sub-app-id", item.id);
      myHeaders.append("access-token", tokenUserInfo);

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch("https://loginv2.timkj.cn/autoLogin/v2/pri/app/get/subAppCallback", requestOptions)
          .then(response => response.json())
          .then(function (res) {
            console.log(res)
            let baseurl
            if (res.data.address.indexOf("?") !== -1) {
              baseurl = res.data.address + "&access_token=" + tokenUserInfo +
                  '&app_id=' +
                  appIdUserInfo +
                  '&sub_app_id=' + item.id + "&config="
            } else {
              baseurl = res.data.address + "?access_token=" + tokenUserInfo +
                  '&app_id=' +
                  appIdUserInfo +
                  '&sub_app_id=' + item.id + "&config="
            }

            console.log(baseurl)
            window.open(baseurl, 'target');


          })
          .catch(error => console.log('error', error));


    },

    //获取用户详细信息
    getUserInfo() {
      const that = this
      clientUtils.get("autoLogin/v2/pri/user/get/userInfo", function (res) {

        //获取用户信息成功 调用获取应用列表接口getMenu
        if (res.data.code === 0) {
          console.log(res.data.data)
          that.userInfo = res.data.data
          that.getMenu()
        } else {
          //失败通知及跳转userLoginPC
          that.$notify.error({
            title: '获取用户信息失败',
            message: res.data.msg + res.data.data
          });
          that.$router.replace('userLogInPC')
        }

      })
    }
  }
}
</script>

<style scoped lang="scss">
// 移动端应用列表容器
.mobile-app-list {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
}

// 顶部Banner
.mobile-banner {
  width: 100%;
  height: 28vh;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(to top, #f5f7fa, transparent);
  }
}

.banner-image {
  width: 100%;
  height: 100%;
}

.banner-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e8f4ff 0%, #f0f9ff 100%);
  color: #909399;
  font-size: 48px;
}

// 主内容区域
.mobile-content {
  flex: 1;
  border-radius: 24px 24px 0 0;
  margin-top: -24px;
  position: relative;
  z-index: 10;
  min-height: 55vh;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
}

// 移动端标签页
.mobile-tabs {
  ::v-deep .van-tabs__wrap {
    padding: 0 16px;
  }

  ::v-deep .van-tabs__nav {
    background: transparent;
    padding-bottom: 4px;
  }

  ::v-deep .van-tab {
    color: #909399;
    font-size: 15px;
    transition: all 0.3s;
  }

  ::v-deep .van-tab--active {
    color: #586cb1;
    font-weight: 600;
  }

  ::v-deep .van-tabs__line {
    height: 3px;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(88, 108, 177, 0.3);
  }
}

// 移动端应用网格
.mobile-app-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  padding: 20px 16px;
}

// 移动端应用卡片
.mobile-app-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 8px;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #ebeef5;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(88, 108, 177, 0.05) 0%, rgba(88, 108, 177, 0.02) 100%);
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:active {
    transform: scale(0.95);
    box-shadow: 0 4px 12px rgba(88, 108, 177, 0.15);

    &::before {
      opacity: 1;
    }

    .mobile-app-icon-wrapper {
      transform: scale(1.05);
    }

    .mobile-app-icon-glow {
      opacity: 1;
    }
  }
}

// 移动端应用图标包装器
.mobile-app-icon-wrapper {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;
}

// 移动端应用图标
.mobile-app-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  transition: all 0.3s;
}

.icon-error {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #c0c4cc;
  font-size: 24px;
  border-radius: 10px;
}

// 移动端应用图标发光效果
.mobile-app-icon-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background: radial-gradient(circle, rgba(88, 108, 177, 0.15) 0%, transparent 70%);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 1;
}

// 移动端应用名称
.mobile-app-name {
  margin-top: 10px;
  font-size: 12px;
  color: #303133;
  text-align: center;
  line-height: 1.4;
  transition: all 0.3s;
  position: relative;
  z-index: 2;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 2px;
}

// 底部用户信息
.mobile-footer {
  width: 100%;
  background: white;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 20px 20px 0 0;
  overflow: hidden;
}

.user-info-section {
  display: flex;
  padding: 20px 16px;
  gap: 16px;
}

// 用户信息左侧
.user-info-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// 用户信息项
.user-info-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.info-icon-wrapper {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(88, 108, 177, 0.1) 0%, rgba(88, 108, 177, 0.05) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #586cb1;
  font-size: 16px;
  flex-shrink: 0;
}

.info-text-wrapper {
  flex: 1;
  min-width: 0;
}

.info-label {
  font-size: 11px;
  color: #909399;
  margin-bottom: 2px;
}

.info-value {
  font-size: 13px;
  color: #303133;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 认证区域
.auth-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

// 认证卡片
.auth-card {
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
  cursor: pointer;

  &:active {
    transform: scale(0.98);
  }
}

.auth-pending {
  background: linear-gradient(135deg, #fff7e6 0%, #fffbe6 100%);
  border: 1px solid rgba(230, 162, 60, 0.3);

  .auth-icon {
    color: #e6a23c;
  }

  .auth-title {
    color: #e6a23c;
  }

  .auth-desc {
    color: #909399;
  }
}

.auth-verified {
  background: linear-gradient(135deg, #f0f9ff 0%, #e8f4ff 100%);
  border: 1px solid rgba(88, 108, 177, 0.3);

  .auth-icon {
    color: #586cb1;
  }

  .auth-title {
    color: #586cb1;
  }

  .auth-desc {
    color: #909399;
  }
}

.auth-icon {
  font-size: 28px;
}

.auth-content {
  text-align: center;
}

.auth-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
}

.auth-desc {
  font-size: 11px;
}

// 玻璃态效果
.glass {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.5);
}

// 响应式设计
@media (max-width: 375px) {
  .mobile-app-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    padding: 16px 12px;
  }

  .mobile-app-card {
    padding: 12px 6px;
  }

  .mobile-app-icon-wrapper {
    width: 56px;
    height: 56px;
  }

  .mobile-app-icon {
    width: 42px;
    height: 42px;
  }

  .mobile-app-name {
    font-size: 11px;
    margin-top: 8px;
  }

  .user-info-section {
    padding: 16px 12px;
  }

  .user-info-item {
    padding: 10px;
  }

  .info-icon-wrapper {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .info-label {
    font-size: 10px;
  }

  .info-value {
    font-size: 12px;
  }
}

@media (min-width: 768px) {
  .mobile-app-list {
    max-width: 480px;
    margin: 0 auto;
  }

  .mobile-app-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
